import "./misc.scss";
import {Link} from "react-router-dom";
import {FaHome} from "react-icons/fa";
import {MdBugReport} from "react-icons/md";
import AccessDenied from "../../assets/svg/access-denied.svg";

export default function ForbiddenPage() {
  const thisYear = new Date().getFullYear();

  return (
    <section
      id="error-report-page"
      className="misc-page"
    >
      <div className="misc-content">
        <div className="jumbotron d-flex flex-column align-items-center gap-3">
          <img src={AccessDenied} className="misc-image" alt="" />
          <h1 className="display-2 text-danger">403</h1>
          <p className="lead">Access denied</p>
          <p className="text-muted">Please contact your admin for more details.</p>
          <div className="d-inline-flex flex-column flex-md-row gap-2">
            <Link className="btn btn-outline-success" to={"/"}>
              <FaHome className="mr-2" />
              Back to home</Link>
            <Link className="btn btn-outline-danger" to={"/"}>
              <MdBugReport className="mr-2" />
              Report Problem</Link>
          </div>
        </div>
      </div>

      <small className="misc-copyright my-5">© {thisYear} ADN DigiNet CMS. All rights
        reserved </small>
    </section>
  );
}
